import React from 'react';
import { CheckIcon } from 'lucide-react';
import { StudyRow } from '../../hooks/useTodayPlan';
export function StudyRowItem({
  row
}: {
  row: StudyRow;
}) {
  return <li className="flex items-center gap-2 py-1.5 pl-2 pr-3" data-id="element-1214" data-mp="15ietuf5l7g8k">
      <button type="button" onClick={row.toggle} aria-pressed={row.done} aria-label={`${row.label}: ${row.done ? 'označi kot neopravljeno' : 'označi kot opravljeno'}`} className="grid h-11 w-11 shrink-0 place-items-center rounded-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent active:scale-95" data-id="element-1215" data-mp="1kew3n1y4omt0">
        <span className={`grid h-7 w-7 place-items-center rounded-lg border-2 ${row.done ? 'border-done bg-done text-white' : 'border-[#C9BBA4] bg-surface text-transparent'}`} data-id="element-1216" data-mp="2342ey3wlec4s">
          <CheckIcon className="h-4 w-4" strokeWidth={3.5} aria-hidden="true" data-id="element-1217" data-mp="2c47l6aq1v4hd" />
        </span>
      </button>
      <span className="min-w-0 flex-1 py-1.5" data-id="element-1218" data-mp="283fare5fytji">
        <span className={`block font-bold leading-snug ${row.done ? 'text-muted' : ''}`} data-id="element-1219" data-mp="284qg3iejc9cq">{row.label}</span>
        <span className="block text-xs text-muted" data-id="element-1220" data-mp="2gczcix1qt7i3">{row.sub}</span>
      </span>
    </li>;
}